<template>
  <div class="ibox">
    <div class="ibox-title"><h5>择日业务办理</h5></div>
    <div class="ibox-content">
    <div class="crud-bar">
      <el-select v-model="type" placeholder="业务类型" clearable @change="fetch" style="width:180px">
        <el-option label="全部类型" value="" />
        <el-option label="自动择日(type 1/3)" value="1" />
        <el-option label="会员(type 2)" value="2" />
        <el-option label="私人定制(type 4-9)" value="4" />
      </el-select>
      <el-select v-model="status" placeholder="状态" clearable @change="fetch" style="width:140px">
        <el-option label="未支付(0)" value="0" />
        <el-option label="已支付(1)" value="1" />
      </el-select>
      <el-button icon="el-icon-refresh" @click="fetch">刷新</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="out_trade_no" label="订单号" width="200" />
      <el-table-column prop="type" label="业务" width="110" />
      <el-table-column prop="price" label="金额" width="90" />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="s">
          <span class="label" :class="s.row.status === '1' ? 'label-success' : 'label-warning'">{{ s.row.status === '1' ? '已支付' : '未支付' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="170" />
      <el-table-column label="操作" width="100">
        <template slot-scope="s">
          <el-button size="mini" @click="openDetail(s.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="订单详情" :visible.sync="detailVisible" width="520px">
      <pre class="detail-pre">{{ detailText }}</pre>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { ordersApi } from '../api/business'

export default {
  name: 'AdminOrderManage',
  data () {
    return {
      loading: false,
      type: '',
      status: '',
      list: [],
      detailVisible: false,
      detailText: ''
    }
  },
  created () { this.fetch() },
  methods: {
    async fetch () {
      this.loading = true
      try {
        this.list = await ordersApi.list(this.type, this.status)
      } catch (e) { this.$message.error(e.uiMessage || e.message) } finally { this.loading = false }
    },
    async openDetail (row) {
      try {
        const d = await ordersApi.detail(row.id)
        this.detailText = JSON.stringify(d, null, 2)
        this.detailVisible = true
      } catch (e) { this.$message.error(e.uiMessage || e.message) }
    }
  }
}
</script>

<style scoped>
.crud-bar { margin-bottom: 16px; display: flex; gap: 12px; }
</style>
